export default __webpack_public_path__ + "93c922a.png";